import React from 'react';
import { AvTooltip } from '@fabric-ui/components';
import { tooltipClasses } from '@mui/material';

export const avTooltipProps: Omit<React.ComponentProps<typeof AvTooltip>, 'children'> = {
  variant: 'message',
  color: 'white',
  muiProps: {
    PopperProps: {
      sx: {
        [`& .${tooltipClasses.tooltip}`]: {
          maxWidth: 'none',
        },
      },
    },
  },
};
